import React, { useMemo, useState } from "react";

import PermissionToolbar from "./PermissionToolbar";

import PermissionGrid from "./PermissionGrid";

const PermissionTab = ({

    user,

    permissions,

    setPermissions,

    loading,

    loadPermissions

}) => {

    const [searchText, setSearchText] = useState("");
    const [selectedModule, setSelectedModule] = useState("");
    const filteredPermissions = useMemo(() => {

        const search = searchText.trim().toLowerCase();

        return permissions.filter(permission => {

            if (selectedModule) {

                if (permission.module !== selectedModule) {

                    return false;

                }

            }

            if (!search) {

                return true;

            }

            return (

                permission.module?.toLowerCase().includes(search) ||

                permission.functionality_name?.toLowerCase().includes(search) ||

                permission.functionality_code?.toLowerCase().includes(search)

            );

        });

    }, [

        permissions,

        searchText,

        selectedModule

    ]);

    const modules = useMemo(() => {

        return [

            ...new Set(

                permissions.map(

                    permission => permission.module

                )

            )

        ].sort();

    }, [permissions]);
    return (

        <>

            <PermissionToolbar
                modules={modules}
                searchText={searchText}
                setSearchText={setSearchText}
                selectedModule={selectedModule}
                setSelectedModule={setSelectedModule}
            />

            <PermissionGrid

                            
                user={user}

                permissions={filteredPermissions}

                setPermissions={setPermissions}

                loading={loading}

                loadPermissions={loadPermissions}

            />

        </>

    );

};

export default PermissionTab;